/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type EmailDomainConfigContainer_settings = {
    readonly protectedEmailDomains: ReadonlyArray<string>;
    readonly disposableEmailDomains: {
        readonly enabled: boolean;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"EmailDomainTableContainer_settings">;
    readonly " $refType": "EmailDomainConfigContainer_settings";
};
export type EmailDomainConfigContainer_settings$data = EmailDomainConfigContainer_settings;
export type EmailDomainConfigContainer_settings$key = {
    readonly " $data"?: EmailDomainConfigContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"EmailDomainConfigContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailDomainConfigContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "protectedEmailDomains",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "DisposableEmailDomainConfiguration",
            "kind": "LinkedField",
            "name": "disposableEmailDomains",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EmailDomainTableContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '5732139aef937a8527aad25e7120968a';
export default node;
